module.exports = __webpack_public_path__ + "static/media/bbuilderThumbnail.3d7233e7.png";